import { PRODUCTION, DEVELOPMENT, LOCAL_PRODUCT_MASTER_URL } from "./const";
import { isEmpty } from "lodash";

export function productMasterURL() {
  const REACT_ENV = process.env.REACT_APP_HOST_ENV;
  const PRODUCT_MASTER_URL =
    !!process.env.REACT_APP_PRODUCT_MASTER_URL && process.env.REACT_APP_PRODUCT_MASTER_URL !== "" ? process.env.REACT_APP_PRODUCT_MASTER_URL : LOCAL_PRODUCT_MASTER_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return PRODUCT_MASTER_URL;
      case PRODUCTION:
        return PRODUCT_MASTER_URL;
      default:
        return PRODUCT_MASTER_URL;
    }
  } else {
    return PRODUCT_MASTER_URL;
  }
}

export const getProductMasterURL = () => {
  return `${productMasterURL()}`;
};
